module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.a288961.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/notokr-regular.woff2
// module id = 4tFf
// module chunks = 0